<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconVideoOff_32"
    viewBox="0 0 32 32"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M4.09 5.577a.834.834 0 0 0-1.18 1.179l2.873 2.872a3.32 3.32 0 0 0-2.388 3.181v6.654a3.333 3.333 0 0 0 3.333 3.333h11.667c.176 0 .341-.019.51-.045l4.69 4.69a.834.834 0 0 0 1.178-1.178zm17.638 13.899v-6.667a3.333 3.333 0 0 0-3.333-3.333h-8.05L21.507 20.64c.135-.364.22-.753.22-1.164m1.667-5.833 3.633-3.028a.834.834 0 0 1 1.367.64v9.776a.833.833 0 0 1-1.367.64l-3.633-3.028z"
        clip-rule="evenodd"
    />
</svg>
